var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDust(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "7.5 7.5 54.5 7.5 7.5 54.5 7.5 7.5",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 22.56,
    y1: 21.96,
    x2: 39.2,
    y2: 50.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#deeafb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 22.14,
    y1: 36,
    x2: 27.53,
    y2: 45.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fde68a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#fde68a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fde171"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 34.27,
    y1: 28.99,
    x2: 39.66,
    y2: 38.32,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 43.47,
    y1: 23.68,
    x2: 48.86,
    y2: 33,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 32.14,
    y1: 36,
    x2: 37.53,
    y2: 45.32,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 44.27,
    y1: 28.99,
    x2: 49.66,
    y2: 38.32,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 53.47,
    y1: 23.68,
    x2: 58.86,
    y2: 33,
    xlinkHref: "#c"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5,31.5l-.32,0a10.49,10.49,0,0,0-19.11-8,7,7,0,0,0-10.57,6,7.21,7.21,0,0,0,.1,1.14A7.5,7.5,0,0,0,18,45.5a4.19,4.19,0,0,0,.5,0v0h28a7,7,0,0,0,0-14Z",
    stroke: "#e6effc",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fill: "url(#b)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 24.89,
    y1: 45.11,
    x2: 28.08,
    y2: 41.92,
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    stroke: "url(#c)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33.03,
    y1: 36.97,
    x2: 40.45,
    y2: 29.55,
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    strokeDasharray: "7 7",
    stroke: "url(#d)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.92,
    y1: 27.08,
    x2: 46.11,
    y2: 23.89,
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    stroke: "url(#e)"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "-2 2; 0 0; -2 2",
    dur: "3s",
    repeatCount: "indefinite"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 34.89,
    y1: 45.11,
    x2: 38.08,
    y2: 41.92,
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    stroke: "url(#f)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.03,
    y1: 36.97,
    x2: 50.45,
    y2: 29.55,
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    strokeDasharray: "7 7",
    stroke: "url(#g)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.92,
    y1: 27.08,
    x2: 56.11,
    y2: 23.89,
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    stroke: "url(#h)"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "-2 2; 0 0; -2 2",
    dur: "3s",
    begin: "-2.5s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDust);
export default __webpack_public_path__ + "static/media/dust.ee0051350cc12877f89d74104b2a14ac.svg";
export { ForwardRef as ReactComponent };